import React from 'react';
import { List } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import RequestWorkspaceListItem from '../workspaces/components/RequestWorkspaceListItem';
import RequestWorkspaceFieldListItems from '../workspaces/components/RequestWorkspaceFieldListItems';

const RequestDestinationList = ({ category, request, withLink }) => (
  <List className="aridhia-request-destination-list">
    {hasMinimumLength(request.workspace_reference) && (
    <RequestWorkspaceListItem value={request.workspace_reference} header="reference" />
    )}
    {!hasMinimumLength(request.workspace_inbox_url) && !hasMinimumLength(request.workspace_reference) && (
    <RequestWorkspaceListItem value={request.workspace_name} />
    )}
    {hasMinimumLength(request.workspace_inbox_url) && (
    <RequestWorkspaceListItem value={request.workspace_name} url={withLink ? request.workspace_inbox_url : null} />
    )}
    {hasMinimumLength(request.workspace_location) && (
    <RequestWorkspaceListItem value={request.workspace_location} header="hub" />
    )}
    {hasMinimumLength(request.destination_namespace) && (
    <RequestWorkspaceListItem value={request.destination_namespace} header="namespace" />
    )}
    {request.workspace_requested && (<RequestWorkspaceFieldListItems code={request.code} category={category} />)}
  </List>
);

export default RequestDestinationList;
